import { Container, Row, Col, Table, Button, Card } from 'react-bootstrap';
import { Download, Printer } from 'react-bootstrap-icons';
import React, { useState, useEffect, } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints';
import Cookies from 'js-cookie';
import html2pdf from 'html2pdf.js';
import axios from 'axios';
import { FaArrowLeft } from 'react-icons/fa';
import { useAuth } from './AuthContext';

export default function FeeRecipt() {
  const {token} =useAuth()
  const navigate = useNavigate();
  
  const { studentId, feeIds } = useParams()
  const location = useLocation();
  const { fee, selectedStudent,selectedStudentIdParams, selectedFees, selectedData, selectedStudentId,selectedCourseId,
    selectedClassId,
     } = location.state || {};
  // console.log("FEES",fee,"SELECTED STUDENT",selectedStudent,"SELECTED FEES",selectedFees,"SELECTED DATA",selectedData,"SELECTED STUDENT ID" ,selectedStudentId,"SELECTED COURSE ID" ,selectedCourseId,"SELECTED CLASS ID" ,selectedClassId,"selectedStudentIdParams",selectedStudentIdParams)
console.log("sectedData:",selectedData)
  console.log("studentId",studentId)
    console.log("feeIds",feeIds)

  const [student, setStudent] = useState(null)
  const [fees, setFees] = useState([])
const [ selectedFeesData,setSelectedFeesData]=useState(location.state?.selectedData)

console.log("selectedFeesData",selectedFeesData)
  const handleBack = () => {
    console.log("selectedStudentIdParams",selectedStudentIdParams)
    if(selectedStudentIdParams){
        navigate(    `/StudentFees/${selectedStudentId }`,
          {
          state: {
            selectedStudent,
            selectedFees,
            selectedData,
            selectedStudentId,
            selectedCourseId,
            selectedClassId,
            selectedStudentIdParams
          },
        })
    }
    else if(selectedStudentId && selectedCourseId && selectedClassId){
       navigate(`/ManageStudentFees/${selectedStudentId }/${selectedCourseId }/${selectedClassId }`,
          {
          state: {
            selectedStudent,
            selectedFees,
            selectedData,
            selectedStudentId,
            selectedCourseId,
            selectedClassId,
            selectedStudentIdParams
          },
        })
    }
   else{
     navigate(`/StudentProfile/${selectedStudentId || selectedStudentIdParams || studentId }`,
          {
          state: {
            selectedStudent,
            selectedFees,
            selectedData,
            selectedStudentId,
            selectedCourseId,
            selectedClassId,
            selectedStudentIdParams
          },
        })
   }
  }
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          BASE_URL+`/printable-fees/${studentId}/${feeIds}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ pass token here
            },
          }
        )
        const { data } = response.data
        setStudent(data.student)
        console.log("DATA FEES:",data.fees)
        setFees(data.fees)
      } catch (error) {
        console.error('Error fetching fee receipt:', error)
      }
    }

    if (studentId && feeIds) {
      fetchData()
    }
  }, [studentId, feeIds])

  const [institutes, setInstitutes] = useState([]);

  useEffect(() => {
    const storedInstitute = Cookies.get("institute_name");
    if (storedInstitute) {
      setInstitutes([{ name: storedInstitute }]);
    }
  }, []);

  useEffect(() => {
    ApiEndpoints.getAllInstitutes().then((res) => {
      if (Array.isArray(res.data.data)) {
        setInstitutes(res.data.data);
      }
    });
  }, []);


  const studentData = selectedStudent || studentId
  console.log("Loaded studentData:", studentData);

  const matchedInstitute = institutes?.find(
    (inst) => inst.institute_id === studentData?.institute_id || selectedStudentId || studentId
  );
  console.log("matchedInstitute",matchedInstitute)
  // const matchedInstituteByUrl = student
// const matchedInstitute = useMemo(() => {
//   if (!studentData || !studentData.institute_id || !Array.isArray(institutes)) return null;
//   return institutes.find(inst => inst.institute_id === studentData.institute_id);
// }, [institutes, studentData]);
// useEffect(() => {
//   console.log("Loaded studentData:", studentData);
//   console.log("Available institutes:", institutes);
// }, [studentData, institutes]);


  // const handleDownload = () => {
  //   let receiptNumber = '';
    
  //   if (fees.length === 1) {
  //     const date = new Date(fees[0].transaction_date);
  //     const year = date.getFullYear();
  //     const month = String(date.getMonth() + 1).padStart(2, '0');
  //     const hexId = fees[0].id.toString(16).toUpperCase();
  //     receiptNumber = `${year}${month}${hexId}`;
  //   }
  
  //   const element = document.getElementById('print_page');
  //   if (!element) return;

  //   element.classList.add('pdf-style');

    
  //   const opt = {
  //     // margin: 10,
  //     // margin: [0, 0, 0, 0],
      
  //   filename: `fee_receipt${receiptNumber ? `_${receiptNumber}` : ''}.pdf`,
  //     image: { type: 'jpeg', quality: 0.98 },
  //     // html2canvas: { scale: 3, useCORS: true },
  //     html2canvas: {
  //       scale: 4,
  //       useCORS: true,
  //       allowTaint: true,
  //       scrollY: 0,
  //     },
  //     jsPDF: { unit: 'mm', format: 'a5', orientation: 'portrait' },
  //     pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },

  //   };

  //   html2pdf().set(opt).from(element).save().then(() => {
  //     element.classList.remove('pdf-style');
  //   });
  // };
const handleDownload = () => {
  let receiptNumber = '';
  
  if (fees.length === 1) {
    const date = new Date(fees[0].transaction_date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const hexId = fees[0].id.toString(16).toUpperCase();
    receiptNumber = `${year}${month}${hexId}`;
  }

  const element = document.getElementById('print_page');
  if (!element) return;

  // Create a clone and apply PDF-specific styles
  const elementClone = element.cloneNode(true);
  document.body.appendChild(elementClone);
  elementClone.classList.add('pdf-style');

  // Apply specific styles for PDF generation
  elementClone.style.width = '148mm'; // A5 width
  elementClone.style.padding = '5mm';
  elementClone.style.fontSize = '10px';
  elementClone.style.lineHeight = '1.2';

  // Make sure table cells are compact
  const tables = elementClone.getElementsByTagName('table');
  for (let table of tables) {
    table.style.borderCollapse = 'collapse';
    table.style.width = '100%';
    table.style.fontSize = '9px';
       
    // Set borders for all cells
    const cells = table.querySelectorAll('td, th');
    cells.forEach(cell => {
      cell.style.border = '1px solid black';
      cell.style.padding = '4px';
    });

  }
  

  const opt = {
    filename: `fee_receipt${receiptNumber ? `_${receiptNumber}` : ''}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      scrollY: 0,
      windowHeight: elementClone.scrollHeight,
      height: elementClone.scrollHeight,
      letterRendering: true,
      ignoreElements: (element) => {
        // Ensure no elements are ignored
        return false;
      }
    },
    jsPDF: { 
      unit: 'mm', 
      format: 'a5',
      orientation: 'portrait',
      hotfixes: ["px_scaling"] // Helps with proper scaling
    },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
    onclone: function(clonedDoc) {
      // Ensure all elements are visible
      clonedDoc.querySelectorAll('td, th').forEach(el => {
        el.style.padding = '2px';
        el.style.fontSize = '9px';
      });
      
      // Explicitly show all table rows
      clonedDoc.querySelectorAll('tr').forEach(el => {
        el.style.display = 'table-row';
      });
      
      // Make sure the table fits
      const table = clonedDoc.querySelector('table');
      if (table) {
        table.style.width = '100%';
        table.style.tableLayout = 'auto';
      }
    }
  };

  // Generate PDF
  html2pdf()
    .set(opt)
    .from(elementClone)
    .save()
    .then(() => {
      document.body.removeChild(elementClone);
    });
};

  const handlePrint = () => {
    const element = document.getElementById('print_page');
    if (!element) return;
    element.classList.add('pdf-style');
    setTimeout(() => {
      window.print();
      element.classList.remove('pdf-style');
    }, 200);
  };

  return (
    <>
<style>
{`
  @media print {
    body, html {
      margin: 0 !important;
      padding: 0 !important;
      font-size: 15px !important;
      width: 450mm !important;
      height: 100% !important;
      overflow: hidden !important;

    }

    .no-print, .print-buttons {
      display: none !important;
    }

    #print_page {
      width: 85% !important;
       min-height: 140mm;
      margin: 0 auto !important;
      // padding: 10mm !important;
      background: white !important;
      box-shadow: none !important;
      // page-break-inside: avoid !important;
       left:-69% !important;
      //  line-height: 4rem !important;
    }

    .print-card,
    .print-status-card,
    .card-table,
    .logo-container,
    .logo-text {
        font-size: 15px !important;
      page-break-inside: avoid !important;
    }
      div.logo-text p.inst-address {
        font-size: 15px !important;
      }


    .logo-container img {
      // height: 110px !important;
    display: block !important;
    height: 100px !important;
    width: auto !important;
    max-height: 100px !important;
    }
  

    .logo-text h4,
    .logo-text p {
      font-size: 25px !important;
      // line-height: 1.5 !important;
    }

    .print-card-text {
      text-align: start !important;
      font-size: 18px !important;
      margin-left: 0rem !important;
      // line-height: 2rem !important;
    }
    
    .sign-row {
      margin-top: 4rem !important; 
      margin-bottom:-4rem !important;
    }
  }

  .pdf-style {
    background: white;
    font-size: 11px;    
    padding: 5mm 10mm;
    width: 100%;
    // margin-top:-1rem;
  }

  .pdf-style .no-print,
  .pdf-style .print-buttons {
    display: none !important;
  }

  @media print {
  .logo-container {
    flex-direction: row !important;         /* Ensure horizontal layout */
    justify-content: flex-start !important; /* Align items to the left */
    align-items: center !important;
    gap: 1rem !important;                   /* Optional spacing */
  }

  .logo-text {
    text-align: left !important;
  }
}

`}
</style>
      <div style={{ marginLeft: '270px' }}>
        <div style={{ backgroundColor: '#f4f6f9', minHeight: '100vh', padding: '40px 0' }}>
          <div className="d-flex justify-content-end no-print">
            <Button onClick={handleBack} >
              <FaArrowLeft className="fs-4 text-white" /> Go Back
            </Button>
          </div>

          <Container className="d-flex justify-content-center" >
            <div>
              <Card
                id="print_page"
                className="shadow-lg p-5 rounded-4 border-0 print-card"
                style={{
                  maxWidth: '900px',
                  // background: 'linear-gradient(135deg, #ffffff, #eef2f5)',
                }}
              >
                {/* <div className="logo-container text-center mb-2">
                  <img
                    src="/tta_logo.jpg"
                    alt="Logo"
                    style={{ height: '100px', objectFit: 'contain' }}
                  />
                </div>

                {matchedInstitute && (
                  <div className="mb-2 text-center logo-text">
                    <h4 className="fw-bold text-primary">{matchedInstitute.name}</h4>
                  </div>
                )} */}

                <div className="logo-container d-flex flex-column flex-md-row align-items-center justify-content-between mb-3 gap-2">
                  {/* <img
                    src="/tta_logo.jpg"
                    alt="Logo"
                    style={{ height: '100px', objectFit: 'contain' }}
                    className="mb-2 mb-md-0"
                  /> */}
                      <img
                    src="/tta_logo.jpg"
                    alt="Logo"
                    style={{ height: '100px', objectFit: 'contain', display:"block" }}
                    className="mb-2 mb-md-0"
                  />

                  {/* {matchedInstitute && matchedInstituteByUrl && ( */}
                    <div className="text-md-start text-center logo-text">
                      <h4 className="fw-bold text-primary mb-0">
                          {matchedInstitute?.name }
                      </h4>
                      <p className="fw-semibold text-muted mb-0 inst-address">
                          {matchedInstitute?.address }
                      </p>
                    </div>
                  {/* )} */}
                </div>

                <Card className="p-4 mb-4 border-0 rounded-3 shadow-sm print-card-text text-start" >
                  <Row className="gy-2">
                    <Col md={6}>
                      <strong>📛 Student Name:</strong> {student?.name || 'Loading...'}
                    </Col>
                    <Col md={6}>
                      <strong>📅 Class:</strong> {student?.class || 'Loading...'}
                    </Col>
                    <Col md={6}>
                      <strong>🆔 Admission No:</strong> {student?.admission_number || 'Loading...'}
                    </Col>
                    {/* {fees.length === 1 && (
                      <Col md={6}>
                        <strong>📄 Receipt No: </strong>
                        {`${new Date(fees[0].transaction_date).getFullYear()}${String(new Date(fees[0].transaction_date).getMonth() + 1).padStart(2, '0')}${fees[0].id.toString(16).toUpperCase()}`}
                      </Col>
                    )} */}

                    {fees.length === 1 ? (
                      <Col md={6}>
                        <strong>📄 Receipt No: </strong>
                        {`${new Date(fees[0].transaction_date).getFullYear()}${String(new Date(fees[0].transaction_date).getMonth() + 1).padStart(2, '0')}${fees[0].id.toString(16).toUpperCase()}`}
                      </Col>
                    ) : (
                      <Col md={6}>
                        <strong>📄 Receipt No: </strong>
                        {(() => {
                          const year = new Date(fees[0]?.transaction_date).getFullYear();
                          const combinedIds = fees.map(fee => fee.id).join(""); // e.g., "2355333"
                          const hexValue = parseInt(combinedIds, 10).toString(16).toUpperCase();
                          return `${year}${hexValue}`;
                        })()}
                      </Col>
                    )}

                  </Row>
                </Card>

               {Array.isArray(fees)&& fees.length>0&&(
                
                <Table bordered hover responsive className="rounded-3 shadow-sm card-table">
                <thead className="bg-primary text-white">
                  <tr>
                    <th>Fees Name</th>
                    <th>Course</th>
                    <th>Month</th>
                    <th>Amount</th>
                    <th>Transaction Amount</th>
                    <th>Discount</th>
                    <th>Payment Method</th>
                    <th>Payment Date</th>
                  </tr>
                </thead>
                <tbody>
                 {fees.map((fee)=>{
                  const matchedFees=selectedData?.find((s)=>s.id===fee.id )
                  console.log("matchedFees",matchedFees)
                  return (
                     <tr>
                    <td>{fee?.fees_name ? fee.fees_name.charAt(0).toUpperCase() + fee.fees_name.slice(1) : 'N/A'}</td>
                    <td>{matchedFees?.course_name || student?.course }</td>
                    <td>{matchedFees?.start_date
                              ? new Date(matchedFees.start_date).toLocaleDateString('en-GB', {
                                day:"2-digit",
                                month:"long",
                                // year:"2-digit"
                              })
                              : 'N/A'}{' '}
                             - {' '}
                    {matchedFees?.end_date
                    ? new Date(matchedFees.end_date).toLocaleDateString('en-GB', {
                      day:"2-digit",
                      month:"long",
                      // year:"2-digit"
                    })
                    : 'N/A'}              
                    </td>     
                    <td>₹{fee?.amount || '0'}</td>
                    <td>₹{fee?.transaction_amount || '0'}</td>
                    <td>₹{fee?.discount || '0'}</td>
                   <td>{fee?.payment_method ? fee.payment_method.charAt(0).toUpperCase()+fee.payment_method.slice(1):"Online"}</td>
                   <td>{fee?.transaction_date
                     ? new Date(fee.transaction_date).toLocaleDateString('en-GB', {
                         day: '2-digit',
                         month: 'long',
                         year: 'numeric',
                       })
                     : 'N/A'}</td>
                   </tr>
                  )
                 })}

                  <tr className="fw-bold bg-light ">
                    <td colSpan={7} className='text-start'>Total Amount</td>
                    {/* <td className="text-success">₹{fee?.transaction_amount || '0'}</td> */}
                    <td className="text-secondary">
                      ₹ {fees.reduce((total, fee) => total + Number(fee?.amount || 0), 0)}
                    </td>
                  </tr>
                    <tr className="fw-bold bg-light text-start">
                    <td colSpan={7}>Total Discount</td>
                    {/* <td className="text-success">₹{fee?.transaction_amount || '0'}</td> */}
                    <td className="text-secondary text-center">
                     - ₹ {fees.reduce((total, fee) => total + Number(fee?.discount || 0), 0)}
                    </td>
                  </tr>
                    <tr className="fw-bold bg-light">
                    <td colSpan={7} className='text-start'>Final Amount</td>
                    {/* <td className="text-success">₹{fee?.transaction_amount || '0'}</td> */}
                    <td className="text-success">
                      ₹ {fees.reduce((total, fee) => total + Number(fee?.transaction_amount || 0), 0)}
                    </td>
                  </tr>
                </tbody>
              </Table>
          
               )}
              

              {fees.length > 0 && (
                <div className="p-1 mt-1  rounded-3  print-status-card">
                  <Row>
                    <Col>
                      <strong>💳 Payment Status:</strong>{' '}
                      <span className={`fw-bold ${fees.every(f => f.fees_status === 'complete') ? 'text-success' : 'text-danger'}`}>
                        {fees.every(f => f.fees_status === 'complete') ? 'Paid ✅' : 'Unpaid ❌'}
                      </span>
                    </Col>
                  </Row>
                </div>
              )}


                <div className="p31 mt-3 text-start terms-condition-card">
                  <h6 className="fw-bold text-decoration-underline mb-2" >Terms & Conditions</h6>
                  <ul className="small" style={{ paddingLeft: '2rem' }}>
                    <li>Fees once paid are non-refundable.</li>
                    <li>Please verify all details on the fee receipt after signing.</li>
                    <li>Visit the institute office for any fee-related queries.</li>
                  </ul>
                </div>

                <Row style={{marginTop:"3rem", marginBottom:"-3rem"}} className='sign-row'>
                    <Col className='text-start fw-bold'>
                          <p>Authorized  Signatory________________________________</p>
                    </Col>
                  </Row>
                <div className="d-flex justify-content-between print-buttons no-print" style={{marginTop:"5rem"}}>
                  <Button onClick={handleDownload} variant="primary">
                    <Download /> Download
                  </Button>
                  <Button onClick={handlePrint} variant="danger">
                    <Printer /> Print
                  </Button>
                </div>
              </Card>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}
